import { getObjectUtil, isPlainObjectUtil } from 'packages/src'

/**
 * Checks whether the given `value` is a `Pointer`.
 * @param  {Object|Instance|Pointer}  value
 * @returns {boolean}
 */
function isPointerReduxUtil (value) {
  return (
    isPlainObjectUtil(value) &&
    value.className &&
    getObjectUtil(value, 'data.id') &&
    !getObjectUtil(value, 'status') &&
    !getObjectUtil(value, 'validation')
  )
}

export {
  isPointerReduxUtil
}
